<script lang="ts">
</script>

<small class="opacity-50 {$$props.class}">(Opcional)</small>
